<app-template [useCard]="true" title="Alterar senha">
  <form class="p-grid ui-fluid p-col-12 col-md-6" [formGroup]="userForm" (submit)="save(userForm.value)">
    <div class="p-col-12 form-group stacked">
      <label for="nome">Nova Senha *</label>
      <input maxlength="50" pInputText formControlName="password" type="password" placeholder="No mínimo 6 caracteres alfanuméricos">
      <app-input-message [form]="userForm" field="password"></app-input-message>
    </div>
    <div class="p-col-12 form-group stacked">
      <label for="nome">Confirmar nova senha *</label>
      <input maxlength="50" pInputText formControlName="confirmPassword" type="password">
      <app-input-message [form]="userForm" field="confirmPassword"></app-input-message>
    </div>

    <div class="actions p-col-12 align-right">
      <button type="button" class="btn-primary" (click)="cancel()">
        Cancelar
      </button>
      <button class="btn-primary" type="submit" [disabled]="userForm.invalid">
        Salvar
      </button>
    </div>
  </form>
</app-template>